export default "/images/coopforsikringer.webp?4ee694724a0fe8516fe2d55e5bae714b";